interface Props {
  name: string
  imageUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-14 w-14 text-base',
} as const

/**
 * A gym's logo, or its initials when it has not uploaded one.
 *
 * Every place the app names a gym goes through this, so a gym without a logo
 * still looks deliberate rather than broken.
 */
export function GymMark({ name, imageUrl, size = 'md', className = '' }: Props) {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[var(--gym-veil)] font-bold text-foreground/55 ${SIZES[size]} ${className}`}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <span aria-hidden>{initials}</span>
      )}
    </span>
  )
}
